import React, { useState, useCallback } from "react";
import { useToast } from "../../../context/toastContext";
import { downloadFromApi } from "../../../utils/downloadBlob";
import Button from "../../../components/ui/Button";
import "./ChainOfCustodySection.css";

// Lets both parties download the auto-generated, unsigned Chain of Custody PDF
// so it can be printed and physically signed before the buyer photographs/
// scans it and uploads it via ReceiptUpload.
const ChainOfCustodySection = ({ order }) => {
    const toast = useToast();
    const [isFetching, setIsFetching] = useState(false);

    const handleDownload = useCallback(async () => {
        setIsFetching(true);
        try {
            await downloadFromApi(`/orders/${order.id}/coc-pdf`, `chain-of-custody-order-${order.id}.pdf`);
        } catch {
            toast.error("Failed to download the Chain of Custody form.");
        } finally {
            setIsFetching(false);
        }
    }, [order.id, toast]);

    if (!order?.coc_pdf_generated_at) return null;

    return (
        <div className="coc-section">
            <h4 className="coc-section__title">Chain of Custody Form</h4>
            <p className="coc-section__hint">
                Both parties must print and physically sign this document — Releasing Party (seller)
                and Receiving Party (buyer) — before the buyer uploads a photo or scan of the signed
                copy below.
            </p>
            <Button variant="secondary" size="sm" onClick={handleDownload} disabled={isFetching} loading={isFetching}>
                Download Chain of Custody Form
            </Button>
        </div>
    );
};

export default ChainOfCustodySection;
